var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoomIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52941 22.5H4.35294C3.80066 22.5 3.35294 22.0523 3.35294 21.5V9.12976M9.52941 22.5V16.0882C9.52941 15.536 9.97713 15.0882 10.5294 15.0882H13.4706C14.0229 15.0882 14.4706 15.536 14.4706 16.0882V22.5M9.52941 22.5H14.4706M14.4706 22.5H19.6471C20.1993 22.5 20.6471 22.0523 20.6471 21.5V9.12976M22.5 10.7647L20.6471 9.12976M1.5 10.7647L3.35294 9.12976M20.6471 9.12976L12.6616 2.08378C12.2836 1.75023 11.7164 1.75023 11.3384 2.08378L3.35294 9.12976",
    stroke: "#065BA9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomIcon);
export default __webpack_public_path__ + "static/media/RoomIcon.b07948d22cceca7b7d140d90d99a1e13.svg";
export { ForwardRef as ReactComponent };